import React, { useState } from "react";
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import { RiDeleteBin6Line } from "react-icons/ri";
import styles from "./EcomProductViewer.module.css";

const categoryOptions = [
  { value: "fashion", label: "Fashion" },
  { value: "electronics", label: "Electronics" },
  { value: "furniture", label: "Furniture" },
];

const subCategoryOptions = [
  { value: "mens", label: "Men's Wear" },
  { value: "mobiles", label: "Mobiles" },
  { value: "chairs", label: "Chairs" },
];

const supplierOptions = [
  { value: "nike", label: "Nike" },
  { value: "apple", label: "Apple" },
  { value: "ikea", label: "IKEA" },
];

const typeOptions = [
  { value: "premium", label: "Premium" },
  { value: "standard", label: "Standard" },
  { value: "budget", label: "Budget" },
];

const selectStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "12px",
    borderColor: state.isFocused ? "#0d6efd" : "#dce1ea",
    boxShadow: "none",
    fontSize: "14px",
    "&:hover": {
      borderColor: "#0d6efd",
    },
  }),
};

const EcomProductViewer = () => {
  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    const imageList = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...imageList]);
  };

  const removeImage = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    setImages(updated);
  };

  return (
    <Container fluid className="py-3">
      <Card className={styles.mainCard}>
        <Card.Body>
          <Row className="g-3">
            <Col lg={3} md={6}>
              <Form.Label className={styles.label}>
                Category
              </Form.Label>

              <Select
                options={categoryOptions}
                styles={selectStyle}
                placeholder="Select Category"
              />
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className={styles.label}>
                Subcategory
              </Form.Label>

              <Select
                options={subCategoryOptions}
                styles={selectStyle}
                placeholder="Select Subcategory"
              />
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className={styles.label}>
                Supplier / Brand
              </Form.Label>

              <Select
                options={supplierOptions}
                styles={selectStyle}
                placeholder="Select Supplier"
              />
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className={styles.label}>
                Type
              </Form.Label>

              <Select
                options={typeOptions}
                styles={selectStyle}
                placeholder="Select Type"
              />
            </Col>
          </Row>
          <Row className="g-3 mt-1">
            <Col xs={12}>
            <label className={styles.uploadBox}>
              <input
                type="file"
                multiple
                accept="image/*"
                hidden
                onChange={handleImageChange}
              />

              <div className={styles.uploadContent}>
                <h6>Upload Product Images</h6>
                <p>Click to upload multiple images</p>
              </div>
            </label>
            </Col>
          </Row>
          {images.length > 0 && (
            <Row className="g-3 mt-1">
              {images.map((img, index) => (
                <Col xl={2} lg={3} md={4} sm={6} xs={6} key={index}>
                  <div className={styles.imageCard}>
                    <img
                      src={img.preview}
                      alt="product"
                      className={styles.productImage}
                    />

                    <div className={styles.overlay}>
                      <button
                        className={styles.deleteBtn}
                        onClick={() => removeImage(index)}
                      >
                        <RiDeleteBin6Line size={18} />
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default EcomProductViewer;